import { HandleOnLoad } from "../../../../../Common/CompanyLogo/types/companyLogo";
import { TEMPLATE_KEYS_TYPE } from "../../../../types/credential";
import { IGetDisplayedAssignmentLogo, KEYS, MENU_KEYS, MENU_OPTION } from "../types/common";
import { getPrimaryLogoUrl } from "../../../../util/common";
import { MANUAL_CREATED_ASSIGNMENT_SUFFIX } from "./standardTemplate";

// type guard
export const isMenuKey = (key: any): key is MENU_KEYS => {
  return KEYS.includes(key);
}

export const MENU_OPTIONS: MENU_OPTION[] = [
  {
    'text': 'Preferences',
    'icon': 'tune',
    'key': 'preferences'
  },
  {
    'text': 'Layout',
    'icon': 'dashboard',
    'key': 'layout'
  },
  {
    'text': 'Presentation Preview',
    'icon': 'visibility',
    'key': 'presentation_preview'
  }
];

export const DEFAULT_TEMAPLTE: TEMPLATE_KEYS_TYPE = 'standard_credential';

// used to consider only assignment refs in a grouped assignment
export const isNonAssignmentKeyInGroupedAssignment = ({
  id,
}: {
  id: string
}): boolean => {
  return id === 'id' || id === 'clientCompanyId';
}

export const getDisplayedAssignmentLogo: IGetDisplayedAssignmentLogo = ({
  datum,
  assignmentsLogoOverride,
  logoPreferences,
}) => {
  // Legacy way to pick user uploaded logos from assignmentsLogoOverride, deprecated due to https://findemjira.atlassian.net/browse/RRINT-997 (Store and remember logo/logo preference uploaded by users)
  const userSavedImg = assignmentsLogoOverride?.[datum['clientCompanyId']];
  const userPreferredLogoObj = logoPreferences?.[datum['clientCompanyId']];
  const userPreferredDefaultLogoObj = logoPreferences?.[datum['clientCompanyId']]?.find(logo => logo.is_default && logo.logo_url);
  const userPreferredLogo = userPreferredDefaultLogoObj?.logo_url;

  let logoKey: string | undefined = undefined;

  for (const groupedAssignment in datum) {
    if (isNonAssignmentKeyInGroupedAssignment({ id: groupedAssignment })) {
      continue;
    }

    const logos = datum[groupedAssignment].client_company?.logos;
    const { url: preferredLogo } = getPrimaryLogoUrl({
      logos,
      source: 'beacon', // Show only RRA logos for PPT since they are more suited for it (rectangular instead of square)
    });

    if (preferredLogo) {
      logoKey = preferredLogo;
      break;
    }
  }

  return {
    effectiveLink: userPreferredLogo ?? userSavedImg ?? logoKey,
    recentLogos: userPreferredLogoObj,
    defaultLogo: userPreferredDefaultLogoObj,
    userUploadedLogo: userPreferredLogo ?? userSavedImg,
  };
};

export const onLoadCompanyImg: HandleOnLoad = ({ img }) => {
  const naturalWidth = img.naturalWidth;
  const naturalHeight = img.naturalHeight;

  const isRectangularImg = naturalWidth / naturalHeight > 1;
  /**
   * https://findemjira.atlassian.net/browse/RRINT-993
   * Rectangular images need to be wider, and not of square dimensions
  */
  if (isRectangularImg) {
    img.width = 122;
  }
};

export const createUniqueManualRef = () => {
  return crypto.randomUUID().replaceAll("-", "") + MANUAL_CREATED_ASSIGNMENT_SUFFIX;
}